type SavedEntry = { saved: boolean; expires: number };
const cache = new Map<string, SavedEntry>();
const TTL = 15_000;
export function savedQuestionState(questionId: string): boolean | undefined {
  const entry = cache.get(questionId); if (!entry || entry.expires <= Date.now()) { cache.delete(questionId); return undefined; }
  return entry.saved;
}
export function notifySavedQuestion(questionId: string, saved: boolean) {
  if (cache.size >= 200) cache.delete(cache.keys().next().value!);
  cache.set(questionId, { saved, expires: Date.now() + TTL });
  if (typeof window !== "undefined") window.dispatchEvent(new CustomEvent("sat:study-saved", { detail: { questionId, saved } }));
}
export function clearSavedQuestionCache() { cache.clear(); }
